import { TABLE_NO_DATA_CELL } from '../constants/data';

const NUMBER_FORMAT = { maximumFractionDigits: 2 };
const LOCALE: Intl.LocalesArgument = 'es-AR';

export const renderAmount = (value: number | undefined, defaultValue: string | undefined = TABLE_NO_DATA_CELL) => {
  if (value === undefined) return defaultValue;

  return `$ ${value.toLocaleString(LOCALE, NUMBER_FORMAT)}`;
};
